
/**
 * @export
 * @enum {string}
 */
export enum SearchType {
    USER = 'USER',
    ACCOUNT = 'ACCOUNT'
}